<script>
import { getPhotoList } from '@/api/yasldpr/photos'
import { HubHeader } from '@/api/consts'
import YasldprCard from '@/components/yasldpr/YasldprCard.vue'

export default {
  name: 'YasldprIndex',
  components: { YasldprCard },
  data() {
    return {
      photoList: [],
      count: 0,
      page: 1,
      limit: 25,
    }
  },
  computed: {
    photos() {
      return this.photoList.slice()
    },
    totalPages() {
      if (this.count <= this.limit) {
        return 1
      }
      return Math.ceil(this.count / this.limit)
    },
  },
  watch: {
    async page() {
      await this.getPhotos()
    },
  },
  async mounted() {
    await this.getPhotos()
  },
  methods: {
    async getPhotos() {
      const resp = await getPhotoList(this.axios, { page: this.page, limit: this.limit })
      this.photoList = resp.data || []
      this.count = resp.headers[HubHeader.TotalItems]
    },
    async photoUpdated(item) {
      await this.getPhotos()
    },
    async photoDeleted(item) {
      await this.getPhotos()
    },
  },
}
</script>

<template>
  <div>
    <v-pagination v-model="page" :length="totalPages"></v-pagination>
    <div>
      <yasldpr-card
        class="ma-auto"
        :photo-item="x"
        v-for="(x, i) in photos"
        :key="x.photo + i"
        @updated="photoUpdated"
        @deleted="photoDeleted"
      ></yasldpr-card>
    </div>
  </div>
</template>
